import { isAllowed } from '../../Apollo/allower';
import permissions from '../../Apollo/permissions';

export function isAllowedToUpdateIntegration() {
  return isAllowed(permissions.updateIntegration);
}
